import { render } from "./geneticNav.vue?vue&type=template&id=a483cf56&scoped=true"
import script from "./geneticNav.vue?vue&type=script&lang=js"
export * from "./geneticNav.vue?vue&type=script&lang=js"

import "./geneticNav.vue?vue&type=style&index=0&id=a483cf56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a483cf56"]])

export default __exports__